import produce from "immer"
import { AVERAGE, FIT } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initQidResultState: types.QidResultState = {
    datapointList: {},

    calculationMethod: AVERAGE,
    format: FIT,
    decimal: 3,

    modelIds: [],
    model: null,
    safetyFunction: null,
    option: null,

    expandedModelIds: [],
    expandedSafetyFunctionIds: [],
    expandedOptionIds: [],
}

const qidResultReducer = produce((
    draft: types.QidResultState = initQidResultState,
    action: ActionTypes = null,
): types.QidResultState => {
    switch (action.type) {
        case types.QID_RESULT_DATAPOINT_LIST:
            draft.datapointList = action.datapointList
            return draft

        case types.QID_RESULT_CALCULATION_METHOD:
            draft.calculationMethod = action.calculationMethod
            return draft

        case types.QID_RESULT_FORMAT:
            draft.format = action.format
            return draft

        case types.QID_RESULT_DECIMAL:
            draft.decimal = action.decimal
            return draft

        case types.QID_RESULT_MODEL_IDS:
            draft.modelIds = action.modelIds
            return draft

        case types.QID_RESULT_MODEL:
            draft.model = action.model
            return draft

        case types.QID_RESULT_SAFETY_FUNCTION:
            draft.safetyFunction = action.safetyFunction
            return draft

        case types.QID_RESULT_OPTION:
            draft.option = action.option
            return draft

        case types.QID_RESULT_EXPANDED_MODEL_IDS:
            draft.expandedModelIds = action.modelIds
            return draft

        case types.QID_RESULT_EXPANDED_SAFETY_FUNCTION_IDS:
            draft.expandedSafetyFunctionIds = action.safetyFunctionIds
            return draft

        case types.QID_RESULT_EXPANDED_OPTION_IDS:
            draft.expandedOptionIds = action.optionIds
            return draft

        default:
            return draft
    }
})
export default qidResultReducer
